import { compose, filter, prop, propOr, sort } from 'ramda';
import { createSelector } from 'reselect';

import { campaignStates } from 'constants/campaigns';
import { sortAlphabeticallyBy } from 'utils/sort';

import { NAME } from './constants';

const empty = [];

export const getDetail = prop(NAME);
// TODO rename to get contactDataColumns
export const getColumns = compose(propOr(empty, 'contactDataColumns'), getDetail);

// TODO this is not selector
export const checkIfCampaignStatusNew = compose(
	(status) => status === campaignStates.NEW,
	prop('campaignStateId'),
	getDetail,
);

export const getUnselectedDataColumns = createSelector(
	getColumns,
	(state, campaignDataColumns) => campaignDataColumns,
	(selectedColumns, columns) => {
		return compose(
			sort(sortAlphabeticallyBy('shortDescription')),
			filter((column) => !selectedColumns.includes(column.id)),
		)(columns);
	},
);
